import { api, getDataWithParams } from "app/helpers/apiHelperV3";
import { SessionHelper } from "app/helpers/sessionHelper";
import { urls } from "./urls";

/**
 * fetch favourites count
 */
export const getCurrentFavouritesCount = (): any => {
  const url = `${urls.data.API_FAVOURITES()}/count`;

  return api
    .get(url, {})
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * fetch favourites list
 */
export const getFavouriteList = (options: Record<string, any>): any => {
  // check if view is asian or european
  const url = `${urls.data.API_FAVOURITES()}${
    SessionHelper.isAsianSessionView() ? "/asian" : ""
  }/events`;

  return getDataWithParams(url, options)
    .then(resp => {
      return resp;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * add favourite
 */
export const addFavourite = (id: string): any => {
  const url = urls.data.API_FAVOURITES();
  const data = {
    eventId: id,
  };
  return api
    .post(url, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * add favourites
 */
export const removeFavourite = (id: number): any => {
  const url = `${urls.data.API_FAVOURITES()}/events/${id}`;
  return api
    .delete(url)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
